import { PRODUCT_IDS } from '@adsk/alloy-provider';

type ProductIdsType = typeof PRODUCT_IDS;

export type ProductTitleKey = ProductIdsType[keyof ProductIdsType];

const PRODUCT_TITLES = {
  [PRODUCT_IDS.MODEL_COORDINATION]: 'Autodesk Model Coordination',
  [PRODUCT_IDS.DESIGN_COLLABORATION]: 'Autodesk Design Collaboration',
  [PRODUCT_IDS.QUANTIFY]: 'Autodesk Quantify',
  [PRODUCT_IDS.TAKEOFF]: 'Autodesk Takeoff',
  [PRODUCT_IDS.COST]: 'Autodesk Cost',
  [PRODUCT_IDS.INSIGHT]: 'Autodesk Insight',
  [PRODUCT_IDS.BUILD]: 'Autodesk Build',
  [PRODUCT_IDS.DOCS]: 'Autodesk Docs',
  [PRODUCT_IDS.ACCOUNT_ADMINISTRATION]: 'Autodesk Account Administration',
  [PRODUCT_IDS.PROJECT_ADMINISTRATION]: 'Autodesk Project Administration',
  [PRODUCT_IDS.AUTOSPECS]: 'Autodesk AutoSpecs',
  [PRODUCT_IDS.BUILDING_CONNECTED]: 'BuildingConnected',
  [PRODUCT_IDS.FORMA_DESIGN]: 'Forma Design',
} as const;

export type ProductTitlesValues =
  (typeof PRODUCT_TITLES)[keyof typeof PRODUCT_TITLES];

const getProductTitle = (key: ProductTitleKey): ProductTitlesValues => {
  return PRODUCT_TITLES[key];
};

export default getProductTitle;
